import React, { useContext, useEffect, useState } from "react";
import '../../Forum.css';
import { ContentContext } from "../content/ContentContext";
import { Badge, Stack } from "react-bootstrap";
import { useUser } from "../loggedUserContext/LoggedUserContext";
import ActivityText from "../activityText/ActivityText";
import LikeButton from "../likebutton/LikeButton";

const Post = ({ postData, index }) => {
  const { setContent, setSelectedPostId } = useContext(ContentContext);
  const { userId } = useUser();
  const [userData, setUserData] = useState(null);
  const [hasLiked, setHasLiked] = useState(false);
  const [hasCommented, setHasCommented] = useState(false);
  const [hasSeen, setHasSeen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [loggedUserData, setLoggedUserData] = useState(null);

  // Utility function to encode user ID with a salt
  const encodeUserId = (userId) => {
    const salt = "6312241f4b246734bbfd5e9ed9120cd7fb64dc6020ef66c2e7f124a5bb1d3d25";
    return btoa(userId + salt); // Base64 encode the user ID with the salt appended
  };

  // Function to handle user click and redirect to the user's profile
  const handleUserClick = () => {
    const encodedUserId = encodeUserId(postData.id_user);
    const url = `https://4construct.ro/homepage/index.php?p=utilizator&id=${encodedUserId}`;
    window.location.href = url;
  };

  const fetchLoggedUserData = () => {
    fetch(`${process.env.REACT_APP_API_URL}/users/${userId}`)
      .then((response) => response.json())
      .then((data) => {
        setLoggedUserData(data);
      })
      .catch((error) => {
        console.error('Error fetching logged user data:', error);
      });
  };

  // Fetch user data associated with the post
  const fetchUserData = () => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/users/${postData.id_user}`)
      .then((response) => response.json())
      .then((data) => {
        setUserData(data);
        setLoading(false);
      })
      .catch((error) => {
        setError("Error fetching user data");
        setLoading(false);
      });
  };

  // Fetch if the user has liked the post
  const fetchIsLiked = (userId, postId) => {
    fetch(`${process.env.REACT_APP_API_URL}/hasLiked/${userId}/${postId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setHasLiked(data); // Assuming `data` is a boolean indicating whether the post is liked
      })
      .catch((error) => {
        console.error('Error checking if liked:', error);
      });
  };

  // Fetch if the user has commented on the post
  const fetchIsCommented = (userId, postId) => {
    fetch(`${process.env.REACT_APP_API_URL}/hasCommentedOnPost/${userId}/${postId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setHasCommented(data); // Assuming `data` is a boolean indicating whether the post is commented
      })
      .catch((error) => {
        console.error('Error checking if commented:', error);
      });
  };

  // Fetch if the user has seen the post
  const fetchIsSeen = (userId, postId) => {
    fetch(`${process.env.REACT_APP_API_URL}/hasSeenPost/${userId}/${postId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setHasSeen(data); // Assuming `data` is a boolean indicating whether the post is seen
      })
      .catch((error) => {
        console.error('Error checking if seen:', error);
      });
  };

  // Log the post view for the user
  const logView = () => {
    if (userId !== "ANONYMOUS")
      fetch(`${process.env.REACT_APP_API_URL}/view`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          post_id: postData.id_postare,
          user_id: userId,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('Post viewed:', data);
        })
        .catch((error) => {
          console.error('Error viewing post:', error);
        });
  };

  // Fetch user and interaction data when the component mounts
  useEffect(() => {
    fetchUserData();
    fetchIsLiked(userId, postData.id_postare);
    fetchIsCommented(userId, postData.id_postare);
    fetchIsSeen(userId, postData.id_postare);
    fetchLoggedUserData();
  }, [userId, postData.id_postare]);

  // Function to handle toggling post details
  const handleToggle = (postId) => {
    setContent("PostDetails");
    setSelectedPostId(postId);

    logView();
  };

  // Loading and error states
  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="card mb-2">
      <div className="card-body p-2 p-sm-3">
        <div className="media forum-item d-flex flex-row">
          <div className="d-flex flex-column me-3">
            <a href="#!" className="redirect-logo d-flex flex-column align-items-center" onClick={handleUserClick}>
              <img src={userData?.profile_picture} className="mr-x rounded-circle" width="50" alt="User" />
              <small>{userData?.username}</small>
              <small>{userData?.companie}</small>
            </a>
            <br /> 
            {postData.unapproved_tags != '[]' && loggedUserData?.is_admin ? <Badge bg="danger" className="me-2" style={{cursor:"pointer"}} onClick={(e) => {
              e.preventDefault();
              handleToggle(postData.id_postare);
            }}>Este nevoie de aprobare</Badge> : null}
            <Stack direction="vertical" gap={2}>
              {JSON.parse(postData.tags).slice(0, 2).map((tag, index) => (
                <Badge bg="secondary" key={index} className="me-2">
                  {tag}
                </Badge>
              ))}
            </Stack>
          </div>
          <div className="media-body ms-3 d-flex flex-column justify-content-start">
            <h6>
              <a href="#!" data-toggle="collapse" data-target=".forum-content" className="text-body" onClick={(e) => {
                e.preventDefault();
                handleToggle(postData.id_postare);
              }}>
                {postData.titlu}
              </a>
            </h6>
            <p className="text-secondary text-truncate">
              {postData.text_postare}
            </p>
            <p className="text-muted">
              <ActivityText postId={postData.id_postare} />
            </p>
          </div>
          <div className="text-muted small text-center align-self-center">
            <Stack direction="vertical" gap={2}>
              <LikeButton
                initialLikes={postData.likes}
                postId={postData.id_postare}
                userId={userId}
              />
              <Badge bg={hasCommented ? "primary" : "secondary"} onClick={() => handleToggle(postData.id_postare)} style={{ cursor: 'pointer' }} className="me-2">{postData.comment_count} <i className="bi bi-chat-dots"></i></Badge>
              <div></div>
              <Badge bg={hasSeen ? "salmon" : "secondary"} className="me-2">{postData.views} <i className="bi bi-eye"></i></Badge>
            </Stack>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Post;
